module Views {
    import Template = kendo.template;

    let defaultForm;
    $(document).ready(() => {
        BidResponse.setScreenStatus();
    });

    export class BidResponse {
        static itemChange(e) {
            let grid = $("#LineItemGrid").data("kendoGrid");
            if (e.action === "add" || e.action === "itemchange") {
                setTimeout(() => {
                    grid.dataSource.sync();
                });
            }
        }

        static setScreenStatus() {
            if ($("#responseStatus").val() != 'Created' && $("#responseStatus").val() != 'Opened') {
                $("#btnNoBid").hide();                
            }
            if ($("#responseStatus").val() == 'Submitted' && ($("#bidStatus").val() == "AwaitingResponse" || $("#bidStatus").val()=="AwaitingNegotiationResponses")) {
                $("#btnReOpen").show();
            }
            else {
                $("#btnReOpen").hide();
                $("#btnSubmit").show();
            }
            if ($("#responseStatus").val() == 'Complete' || $("#responseStatus").val() == 'Awarded' || $("#responseStatus").val() == 'Submitted') {
                $("#btnSubmit").hide();                
            }
            if ($("#bidOpen").val() == "False") {
                $("#btnSubmit").hide();
                $("#btnNoBid").hide();
            }

            setTimeout(() => {
                Views.BidResponse.gridRefreshTotals(null);
            }, 500);
        }

        static gridRequestEnd(e) {
            if (e.type == 'read') {
                let bidType = $("#bidType").val();
                if (bidType == "Logistics") {
                    setTimeout(() => {
                        BidResponse.conditionalSum();
                    }, 1000);
                }
                KendoExtension.Grid.adjustGridSize("LineItemGrid");
            }
        }
        static gridRefreshTotals(e) {            
        }

        static conditionalSum() {
            let grid = $("#LineItemGrid").data("kendoGrid");
            let data = grid.dataSource.data();
            let item, sum = 0;
            for (let idx = 0; idx < data.length; idx++) {
                item = data[idx];
                if (item.ResponseType === 0) {
                    if (item.Status == 2 || item.Status == 3 || item.Status == 4 || (item.Status==5 && item.TotalNegotiatedPrice > 0)) {
                        sum += item.TotalNegotiatedPrice;
                    }
                    else {
                        sum += item.TotalPrice;
                    }                    
                }
                if (item.ResponseType == 0) {
                    $('tr[data-uid="' + item.uid + '"] ').addClass("regular-item");
                }
                else if (item.ResponseType == 1) {
                    $('tr[data-uid="' + item.uid + '"] ').addClass("alternate-item");
                }
            }
            if (sum > 0) {
                $("#btnSubmit").prop('disabled', false);
            }
            else {
                $("#btnSubmit").prop('disabled', true);
            }
            let sumToString = kendo.toString(sum, "c");
            $(".total-price span").text(sumToString);
            return sumToString;
        }

        static conditionalAltSum() {
            let grid = $("#LineItemGrid").data("kendoGrid");
            let data = grid.dataSource.data();
            let item, sum = 0;
            for (let idx = 0; idx < data.length; idx++) {
                item = data[idx];
                if (item.ResponseType === 1 && item.TotalPrice) {
                    sum += item.TotalPrice;
                }
            }            
            
            return kendo.toString(sum, "c");
        }

        static CheckBidderInfo() {
            let bidder = $("#BidResponse_BidderName").val();
            let bidderEmail = $("#BidResponse_BidderEmail").val();
            let regexN = new RegExp(/^(?!(^\s+$))(?=[a-zA-Z0-9])^([a-zA-Z0-9&,.\s_-]{3,100})$/)
            let regexE = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            let nameVerify = regexN.test(bidder.toString());
            let emailVerify = regexE.test(bidderEmail.toString());
            return (nameVerify && emailVerify);
        }

        static AllItemsComplete() {
            let grid = $("#LineItemGrid").data("kendoGrid");
            let data = grid.dataSource.data();
            let item;
            let isComplete = true;
            for (let idx = 0; idx < data.length; idx++) {
                item = data[idx];
                if (item.ResponseType === 0 && (!item.TotalPrice || item.TotalPrice == 0) && (!item.TotalNegotiatedPrice || item.TotalNegotiatedPrice == 0) && (!item.TotalAlternatePrice || item.TotalAlternatePrice == 0)) {
                    isComplete = false;
                }
            } 
            return isComplete;
        }

        static NoBid() {            
            let a = confirm("Submit a No Bid Response?");
            if (a) {
                let bidRequestId = $("#requestId").val();
                window.location.replace("/BidResponse/NoBid?Id=" + bidRequestId.toString());
            }
            return false;
        }

        static ExportItems() {
            
                let bidRequestId = $("#requestId").val();
                window.location.replace("/BidResponse/ExportItems?Id=" + bidRequestId.toString());
            
            return false;
        }

        static ReOpenBid() {
            let a = confirm("ReOpen Bid?");
            if (a) {
                let bidRequestId = $("#requestId").val();
                let postData = JSON.stringify({
                    "token": bidRequestId
                });

                $.ajax({
                    url: '/BidResponse/ReOpenBid',
                    dataType: 'json',
                    type: 'post',
                    contentType: 'application/json',
                    data: postData,
                    processData: false,
                    success: function (data, textStatus, jQxhr) {
                        toastr.success("Bid Reopened Successfully.");
                        location.reload();
                    },
                    error: function (jqXhr, textStatus, errorThrown) {  
                        toastr.error('An error occured: ' + textStatus);
                    }
                });
            }
            return false;
        }

        static SubmitBid() {
            let response = false;
            if (!this.CheckBidderInfo()) {
                toastr.info("Please enter the name and email of the bidder sumbitting this Bid.");
                return false;
            }
            else if (!this.AllItemsComplete()) {
                response = confirm("Incomplete Bid.\nAll items do not have a bid amount.\nSubmit Bid Anyway?")
            }
            else {
                response = confirm("Submit Bid?");
            }
            if (response) {
                let bidRequestId = $("#requestId").val();
                let bidder = $("#BidResponse_BidderName").val();
                let bidderEmail = $("#BidResponse_BidderEmail").val();
                let postData = JSON.stringify({
                    "token": bidRequestId,
                    "bidder": bidder,
                    "bidderEmail": bidderEmail
                });

                $.ajax({
                    url: '/BidResponse/SubmitBid',
                    dataType: 'json',
                    type: 'post',
                    contentType: 'application/json',
                    data: postData,
                    processData: false,
                    success: function (data, textStatus, jQxhr) {
                        toastr.success('Bid Submitted Successfully.');
                        $("#LineItemGrid").data("kendoGrid").setOptions({ editable: false });
                        $("#btnNoBid").hide();
                        $("#btnSubmit").hide();
                        location.reload();
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                        toastr.error('An error occured: ' + errorThrown);
                        //location.reload();
                    }
                });
            }
            return false;
        }

        static SaveBidResponseItem() {
            if (BidResponse.isValid("frmBidEdit")) {
                let formData = $("#frmBidEdit").serialize();
                let url = $("#frmBidEdit").attr("action");
                $.ajax({
                    url: url,
                    type: 'post',
                    data: formData,
                    success: function (data, textStatus, jQxhr) {
                        toastr.success('Bid Item Saved.');
                        Views.BidResponse.saveDefaultForm();
                        Views.BidResponse.ReloadQuickEdit();
                        Views.BidResponse.closeCommonDialog();
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                        console.log(errorThrown);
                        toastr.error('An error occured: ' + textStatus);
                        location.reload();
                    }
                });
            }
            return false;
        }

        

        static OnSubmit(e) {
            console.log('onSubmit');
            $.ajax({
                type: "POST",
                url: '/BidResponseLineItem/ProcurementLineItemTableUpdate',
                data: JSON.stringify(e.data),
                contentType: "application/json",
                dataType: "json",
                success: function (result) {
                    e.success(result.Updated, "update");
                    e.success(result.Created, "create");
                    e.success(result.Destroyed, "destroy");
                    Views.BidResponse.refreshGrid("LineItemGrid");
                },
                error: function (xhr, httpStatusMessage, customErrorMessage) {
                    toastr.success(httpStatusMessage);
                }
            });
        }

        static OnRead(options) {
            let bidRequestId = $("#bidRequestId").val();
            $.ajax({
                url: '/BidResponse/GetResponseItems/'+ bidRequestId,
                dataType: "json",
                success: function (result) {
                    console.log(result.Data);
                    options.success(result.Data);
                },
                error: function (result) {
                    options.error(result);
                }
            });
        }

        static ReloadQuickEdit() {
            let bidRequestId = $("#bidRequestId").val();
            $.ajax({
                url: '/BidResponse/ProcurementLineItemsTable/' + bidRequestId + '?ts=' + event.timeStamp,
                dataType: 'html',
                success: function (data) {
                    $("#ProcurementSpreadsheetHolder").html(data);
                }
            });
        }

        static GridEndRequest(e) {
            KendoExtension.Grid.onRequestEndWithGridResize(e);
            Views.BidResponse.gridRefreshTotals(null);
        }

        static openCommentDialog(url) {
            $("#commonDialog").data("kendoWindow").content("Test");
            $('#commonDialog').load(url, function (response, status, xhr) {
                if (status === "error") {
                    try {
                        let message = $.parseJSON(response);
                        toastr.error(message);

                        // get the server error
                    } catch (e) {
                        console.log(e);
                        toastr.error("Error parsing server response");
                    }
                } else {
                    let wnd = $("#commonDialog").data("kendoWindow");
                    wnd.options.width = 800;
                    wnd.title("Comment Editor");
                    wnd.refresh(url);
                    wnd.open().center();
                }
            });
        }

        static openAlternativeDialog(url) {
            let wnd = $("#commonDialog").data("kendoWindow");
            wnd.options.width = "90%"; 
            wnd.options.height = "75%";            

            wnd.title("Bid Item Response Editor");
            wnd.refresh(url);
            setTimeout(() => {
                $("input[type=text]").on("focus", function () {
                    $(this).select();
                });
                let numerictextbox = $("#OriginalPricePerUnit").data("kendoNumericTextBox");
                if (numerictextbox != null) {
                    numerictextbox.focus();
                }
                wnd.center().open();
            }, 1000);
        }

        static openMessageDialog() {
            let requestId = $("#requestId").val();
            let url = "/BidResponse/MessageDialog/" + requestId;
            let wnd = $("#messageDialog").data("kendoWindow");
           wnd.content("Loading...");
            $('#messageDialog').load(url, function (response, status, xhr) {
                if (status === "error") {
                    try {
                        let message = $.parseJSON(response);
                        toastr.error(message);
                        // get the server error
                    } catch (e) {
                        console.log(e);
                        toastr.error("Error parsing server response");
                    }
                } else {                    
                    wnd.options.width = 500;
                    wnd.title("Request Due Date Extension");
                    wnd.refresh(url);
                    wnd.open().center();
                }
            });
        }

        static openNoBidResponseDialog() {
            let requestId = $("#requestId").val();
            let url = "/BidResponse/NoBidResponseForm/" + requestId;
            let wnd = $("#messageDialog").data("kendoWindow");
            wnd.content("Loading...");
            $('#messageDialog').load(url, function (response, status, xhr) {
                if (status === "error") {
                    try {
                        let message = $.parseJSON(response);
                        toastr.error(message);
                        // get the server error
                    } catch (e) {
                        console.log(e);
                        toastr.error("Error parsing server response");
                    }
                } else {

                    wnd.options.width = 500;
                    wnd.title("No Bid Response Reason");
                    wnd.refresh(url);
                    wnd.open().center();
                }
            });
        }

        static openDescriptionViewWindow(url) {
            let kWindow = $("#descriptionView").data("kendoWindow");
            kWindow.content("Loading..." + url);
            $("#descriptionView").load(url, function (response, status, xhr) {
                if (status === "error") {
                    toastr.error('Unable to load description.');
                } else {
                    kWindow.title("Description");
                    kWindow.setOptions({
                        height: kWindow.wrapper.height(),
                        minHeight: 300,
                        maxHeight: 0.8 * $(window).height(),
                        width: kWindow.wrapper.height(),
                        minWidth: 300,
                        maxWidth: 0.8 * $(window).width(),
                    });
                    kWindow.open().center();
                }
            });
        }

        static sendMessage() {
            if (BidResponse.isValid("frmMessage")) {
                let formData = $("#frmMessage").serialize();
                let url = $("#frmMessage").attr("action");
                $.ajax({
                    url: url,
                    type: 'post',
                    data: formData,
                    success: function (data, textStatus, jQxhr) {
                        toastr.success('Request to Extend Due Date Sent.');
                        Views.BidResponse.closeMessageDialog();
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                        console.log(errorThrown);
                        toastr.error('An error occured: ' + textStatus);
                    }
                });
            }
            return false;
        }

        static saveDefaultForm() {
            defaultForm = $("#frmBidEdit").serialize();
        }

        static checkIfFormChanged() {
            let checkForm = $("#frmBidEdit").serialize();
            if (defaultForm !== checkForm)
                return true;
            else
                return false;
        }

        static closeCommonDialog() {
            $("#LineItemGrid").data("kendoGrid").dataSource.read();
            $("#commonDialog").data("kendoWindow").close();
        }

        static refreshGrid(gridName) {
            $("#" + gridName).data("kendoGrid").dataSource.read(); 
        }

        static wndDeactivate() {
            $("#commonDialog").data("kendoWindow").content("");
        }

        static closeMessageDialog() {
            $("#messageDialog").data("kendoWindow").close();
        }

        static commentClosed(e) {
            if (Views.BidResponse.checkIfFormChanged()) {
                if (confirm("Your changes will be lost.  Do you wish to continue?")) {
                    $("#LineItemGrid").data("kendoGrid").dataSource.read();
                } else {
                    e.preventDefault();
                }
            }
            else {
                $("#LineItemGrid").data("kendoGrid").dataSource.read();
            }
        }

        static AlternateItemEditEvent(e) {
            KendoExtension.Grid.onEdit(e);
            if ($("#ShipmentType")) {
                $("#ShipmentType").bind("change", BidResponse.setTruckTypeVisibleState);
                BidResponse.setTruckTypeVisibleState();
            }
            e.container.data().kendoWindow.bind("deactivate", "Views.BidResponse.endEdit");
        }

        static setTruckTypeVisibleState() {
            let shipType = $("#ShipmentType").val();
            if (shipType == 4) {
                $("#truckTypeEntry").show();
                $("#truckQuantityEntry").show();
            }
            else {
                $("#truckTypeEntry").hide();
                $("#truckQuantityEntry").hide();
                $("#truckQuantityEntry #Quantity").val(1);
            }
        }

        static endEdit(e) {
            KendoExtension.Grid.onDataBound(e);
        }

        static toggleDetails(e) {
            let imageTag = $("#colapseIcon");
            let panel = $("#detailsPanel");
            panel.toggle();
            
            if (panel.is(":visible")) {
                imageTag.removeClass("fa-chevron-down");
                imageTag.addClass("fa-chevron-up");                
                $("#btnToggle")[0].innerHTML = "<i class='fa fa-chevron-up' id='colapseIcon'></i>Hide Details";
            }
            else {
                imageTag.removeClass("fa-chevron-up");
                imageTag.addClass("fa-chevron-down");
                $("#btnToggle")[0].innerHTML = "<i class='fa fa-chevron-down' id='colapseIcon'></i>Show Details";
            }
            KendoExtension.Grid.adjustSize($("#LineItemGrid").data("kendoGrid"));

        }

        static isValid(frmName) {
            $('.validation-summary-errors').empty();
            let kendoValid = true;
            let validator = $("#" + frmName).kendoValidator().data("kendoValidator");
            if (validator) {
                kendoValid = validator.validate();
            }
            let html = "<ul>";

            //Load kendo validation errors
            if (validator.errors().length > 0) {
                for (let idx = 0; idx < validator.errors().length; idx++) {
                    html += "<li>" + validator.errors()[idx] + "</li>";
                }
            }
            html += "</ul>";

            if (!kendoValid) {
                return false;
            }
            return true;
        }   

        static onPostUpload(e) {
            if (e.operation === "upload") {
                if (e.response.Status === 'Ok') {
                    $("#documentGrid").data("kendoGrid").dataSource.read();
                }
                else {

                    toastr.error('Error uploading file. Please try again.');
                }
            }
        }

        static onSelect(e) {
            if (e.files[0].size > 6057456) {
                toastr.error('Please upload a smaller file, this file is over the 6MB maximum.');

                e.preventDefault();
            }
        }

        static onPreUpload(e) {
            // Array with information about the uploaded files
            let files = e.files;

            //Check the extension of each file and abort the upload if it is not .jpg
            $.each(files, function () {
                if (this.extension.toLowerCase() === ".exe") {

                    toastr.error(".EXE files may not be uploaded.");
                    e.preventDefault();
                }
            });
        }

        static onCommentDataBound(e) {
            KendoExtension.Grid.onDataBound(e);
            let grid = $("#gridComments").data("kendoGrid");
            let gridData = grid.dataSource.view();

            for (let i = 0; i < gridData.length; i++) {
                let currentUid = gridData[i].uid;
                if (!gridData[i].IsEditable) {
                    let currenRow = grid.table.find("tr[data-uid='" + currentUid + "']");
                    let editButton = $(currenRow).find(".k-grid-edit,.k-grid-edit-command");
                    let deleteButton = $(currenRow).find(".k-grid-delete, .k-grid-delete-command, .k-grid-remove-command");
                    editButton.hide();
                    deleteButton.hide();
                }
            }
        }

        static itemDataBound(e) {
            if ($("#responseStatus").val() == 'Awarded') {
                let grid = e.sender;            
                let data = grid.dataSource.data();
                $.each(data, function (i, row) {
                    if (row.Status == 5) {
                        $('tr[data-uid="' + row.uid + '"] ').addClass("awarded");
                    }
                    else {
                        $('tr[data-uid="' + row.uid + '"] ').addClass("notAwarded");
                    }
                });
            }
         }

        static onDocumentDataBound(e) {
            KendoExtension.Grid.onDataBound(e);
            let grid = $("#documentGrid").data("kendoGrid");
            let gridData = grid.dataSource.view();

            for (let i = 0; i < gridData.length; i++) {
                let currentUid = gridData[i].uid;
                if (!gridData[i].IsEditable) {
                    let currenRow = grid.table.find("tr[data-uid='" + currentUid + "']");
                    let editButton = $(currenRow).find(".k-grid-edit, .k-grid-edit-command");
                    let deleteButton = $(currenRow).find(".k-grid-delete, .k-grid-delete-command, .k-grid-remove-command");
                    editButton.hide();
                    deleteButton.hide();
                }
            }
        }
    }
}
